import { render } from "./AdminPushBroadcast.vue?vue&type=template&id=3d7a5c96&scoped=true&ts=true"
import script from "./AdminPushBroadcast.vue?vue&type=script&lang=ts"
export * from "./AdminPushBroadcast.vue?vue&type=script&lang=ts"

import "./AdminPushBroadcast.vue?vue&type=style&index=0&id=3d7a5c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7a5c96"]])

export default __exports__